/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Script } from '../models/Script';
import type { ScriptCategory } from '../models/ScriptCategory';
import type { ScriptCategoryForm } from '../models/ScriptCategoryForm';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ScriptCategoryRestControllerService {
    /**
     * @returns ScriptCategory OK
     * @throws ApiError
     */
    public static editScriptCategory({
        creatorId,
        id,
        requestBody,
    }: {
        creatorId: number,
        id: number,
        requestBody: ScriptCategoryForm,
    }): CancelablePromise<ScriptCategory> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/dashboard/api/v1/settings/scripts/category/category',
            query: {
                'creatorId': creatorId,
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ScriptCategory OK
     * @throws ApiError
     */
    public static addScriptCategory({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: ScriptCategoryForm,
    }): CancelablePromise<ScriptCategory> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/scripts/category/category',
            query: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Script OK
     * @throws ApiError
     */
    public static removeScriptCategory({
        creatorId,
        id,
        contentPolicy = 'UNLINK',
    }: {
        creatorId: number,
        id: number,
        contentPolicy?: 'UNLINK' | 'DELETE',
    }): CancelablePromise<Array<Script>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/dashboard/api/v1/settings/scripts/category/category',
            query: {
                'creatorId': creatorId,
                'id': id,
                'contentPolicy': contentPolicy,
            },
        });
    }
    /**
     * @returns ScriptCategory OK
     * @throws ApiError
     */
    public static apiOrderScriptCategory({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: Record<string, any>,
    }): CancelablePromise<Array<ScriptCategory>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/scripts/category/category/order',
            query: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ScriptCategory OK
     * @throws ApiError
     */
    public static moveScriptCategory({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: Array<number>,
    }): CancelablePromise<Array<ScriptCategory>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/scripts/category/category/move',
            query: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns ScriptCategory OK
     * @throws ApiError
     */
    public static apiOrderScriptCategories({
        creatorId,
        requestBody,
    }: {
        creatorId: number,
        requestBody: Record<string, any>,
    }): CancelablePromise<Array<ScriptCategory>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/dashboard/api/v1/settings/scripts/category/categories/order',
            query: {
                'creatorId': creatorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
